<template>
	<horizontal-bar :data="data" :options="options" />
</template>

<script>
import HorizontalBar from './HorizontalBar.vue'

const HorizontalBarChart = {
	props: ['data', 'options'],
	components: { HorizontalBar }
}

export default HorizontalBarChart
export { HorizontalBarChart as mdbHorizontalBarChart }
</script>
